import Dexie from "dexie";
import {  BookRecord, EditionRecord, PrintRecord, GroupRecord } from "./Types";

// if (true){
if (!window.indexedDB) {
    console.warn("Not using indexeddb!")
    Dexie.dependencies.indexedDB = require('fake-indexeddb');
    Dexie.dependencies.IDBKeyRange = require('fake-indexeddb/lib/FDBKeyRange');
}

export type StringIndexTable<T> = Dexie.Table<T, string>;
export type EditionsTable = StringIndexTable<EditionRecord>;
export type BooksTable =  StringIndexTable<BookRecord>;
export type PrintsTable = StringIndexTable<PrintRecord>;
export type GroupsTable = StringIndexTable<GroupRecord>;

export class BlakeDexie extends Dexie {
    editions: EditionsTable;
    books: BooksTable;
    prints: PrintsTable;
    groups: GroupsTable;
    
    constructor() {

        super("yaledh-blake");

        this.version(3).stores({
            editions: "&id,year,bookID",
            books: "&id", // title
            prints: "&id,groupID",
            groups: "&id"
        })

        this.version(2).stores({
            editions: "&id,year,bookID",
            books: "&id", // title
            prints: "&id,groupID",
        })

        this.version(1).stores({
            editions: "&id,year,bookID",
            books: "&id", // title
            prints: "&id,groupID",
        })



        this.editions = this.table("editions");
        this.books = this.table("books");
        this.prints = this.table("prints");
        this.groups = this.table("groups");

    }

}
